import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import useScrollFlags from '../hooks/useScrollFlags';
import { useWhatsApp } from '../context/WhatsAppContext';
import site from '../data/site';
import './Navbar.css';

export default function Navbar() {
  const { isScrolled } = useScrollFlags();
  const { open: openWhatsApp } = useWhatsApp();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = isMobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isMobileOpen]);

  const isHome = location.pathname === '/';
  const transparent = isHome && !isScrolled;

  const links = [
    { to: '/', label: 'Home', end: true },
    { to: '/menu', label: 'Menu' },
    { to: '/market', label: 'Market' },
    { to: '/contact', label: 'Contact' }
  ];

  return (
    <>
      <nav className={`nav ${isScrolled ? 'nav--scrolled' : ''} ${transparent ? 'nav--transparent' : 'nav--solid'}`}>
        <div className="nav__container">
          <Link to="/" className="nav__brand" aria-label="H2 Fresh home">
            <span className="nav__brand-top">
              <span className="nav__brand-h">H</span>
              <span className="nav__brand-2">2</span>
              <span className="nav__brand-fresh">Fresh</span>
            </span>
          </Link>

          <ul className="nav__links">
            {links.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  end={l.end}
                  className={({ isActive }) => 'nav__link' + (isActive ? ' nav__link--active' : '')}
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="nav__actions">
            <a href={`tel:${site.phones[0].tel}`} className="nav__call" aria-label={`Call ${site.phones[0].display}`}>
              <span className="nav__call-icon" aria-hidden="true">📞</span>
              <span className="nav__call-num">{site.phones[0].display}</span>
            </a>
            <button onClick={openWhatsApp} className="btn btn-whatsapp nav__wa">
              📱 WhatsApp
            </button>
          </div>

          <button
            className={`nav__hamburger ${isMobileOpen ? 'is-open' : ''}`}
            onClick={() => setIsMobileOpen((o) => !o)}
            aria-label="Toggle menu"
            aria-expanded={isMobileOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      <div className={`nav-drawer ${isMobileOpen ? 'is-open' : ''}`} role="dialog" aria-modal="true" aria-label="Mobile menu">
        <div className="nav-drawer__overlay" onClick={() => setIsMobileOpen(false)}></div>
        <div className="nav-drawer__panel">
          <button
            className="nav-drawer__close"
            onClick={() => setIsMobileOpen(false)}
            aria-label="Close menu"
          >×</button>
          <span className="eyebrow-script nav-drawer__welcome">Welcome</span>
          <ul className="nav-drawer__links">
            {links.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  end={l.end}
                  className={({ isActive }) => 'nav-drawer__link' + (isActive ? ' is-active' : '')}
                  onClick={() => setIsMobileOpen(false)}
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <div className="nav-drawer__actions">
            <a href={`tel:${site.phones[0].tel}`} className="btn btn-gold">📞 Call {site.phones[0].display}</a>
            <button
              className="btn btn-whatsapp"
              onClick={() => { openWhatsApp(); setIsMobileOpen(false); }}
            >
              📱 Join WhatsApp
            </button>
          </div>
          <p className="nav-drawer__address">{site.address.line1}<br/>{site.address.line2}</p>
        </div>
      </div>
    </>
  );
}
